/**
 * @generated SignedSource<<1427a67039e444907ae2107e5e9e3ab0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HelpObjectStoreSearchAlgorithm = "KEYWORD_SEARCH_ON_ISSUES" | "KEYWORD_SEARCH_ON_PORTALS_BM25" | "KEYWORD_SEARCH_ON_PORTALS_EXACT_MATCH" | "KEYWORD_SEARCH_ON_REQUEST_TYPES_BM25" | "KEYWORD_SEARCH_ON_REQUEST_TYPES_EXACT_MATCH" | "%future added value";
export type HelpObjectStoreSearchBackend = "JIRA" | "SEARCH_PLATFORM" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type portalItemFragment$data = {
  readonly __typename: "HelpObjectStoreSearchResult";
  readonly description: string;
  readonly displayLink: string;
  readonly id: string;
  readonly isExternal: boolean;
  readonly searchAlgorithm: HelpObjectStoreSearchAlgorithm | null | undefined;
  readonly searchBackend: HelpObjectStoreSearchBackend | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"resourceIconFragment">;
  readonly " $fragmentType": "portalItemFragment";
};
export type portalItemFragment$key = {
  readonly " $data"?: portalItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"portalItemFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "portalItemFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "__typename"
      },
      "action": "THROW",
      "path": "__typename"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "title"
      },
      "action": "THROW",
      "path": "title"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "description"
      },
      "action": "THROW",
      "path": "description"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "displayLink"
      },
      "action": "THROW",
      "path": "displayLink"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "isExternal"
      },
      "action": "THROW",
      "path": "isExternal"
    },
    {
      "kind": "ScalarField",
      "name": "searchBackend"
    },
    {
      "kind": "ScalarField",
      "name": "searchAlgorithm"
    },
    {
      "kind": "FragmentSpread",
      "name": "resourceIconFragment"
    }
  ],
  "type": "HelpObjectStoreSearchResult"
};

(node as any).hash = "f6e8d34d3a2e44d4a4de403218747af5";

export default node;
